export const GET_USERS_LIST = "GET_USERS_LIST";
export const GET_AREAS = "GET_AREAS";
export const GET_AREAS_BY_USER = "GET_AREAS_BY_USER";
export const DELETE_AREA = "DELETE_AREA";
export const SAVE_AREA_USER = "SAVE_AREA_USER";
export const REGISTER_USERS = "REGISTER_USERS";
export const REGISTER_AREAS = "REGISTER_AREAS";
export const REGISTER_AREAS_BY_USER = "REGISTER_AREAS_BY_USER";
export const AREA_ERROR = "AREA_ERROR";


